import { render, staticRenderFns } from "./orderServicerEnquiry.vue?vue&type=template&id=3ab7b928&"
import script from "./orderServicerEnquiry.vue?vue&type=script&lang=ts&"
export * from "./orderServicerEnquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports